import React from 'react';

import QAHiddenElement from './qahiddenelement';
import * as ApplicationHelper from '../../helpers/application_helper';
import Actions from '../../actions/actions';

import { useSelector } from 'react-redux';
import LocationHelper from '../../helpers/location_helper';
import ShowMoreText from '../forms/show_more_text';

const QAHiddenMini = () => {
  const user = useSelector((redux) => redux.user);
  try {
    if (
      ApplicationHelper.isSelenium() ||
      user?.atype !== 'CPF' ||
      LocationHelper.getEnvByDomain() === 'prod' ||
      window.location.href?.includes('/admin/') ||
      !window.location.href?.includes('/admin')
    ) {
      return <div></div>;
    }

    const users = [
      { userid: 84102, username: 'concert_qaa_medallion_admin@cpf.com' },
      { userid: 84106, username: 'concert_qaa_medallion_noprops@cpf.com' },
      { userid: 145409, username: 'concert_qaa_med_all_admin@cpf.com' },
      { userid: 114130, username: 'concert_qaa_medallion_rbpall_admin@cpf.com' },
      { userid: 153226, username: 'qaa_cash_admin@beamfintech.com' },
      { userid: 84101, username: 'p3_medallion_admin@cpf.com' },
      { userid: 84103, username: 'p3_medallion_noprops@cpf.com' },
    ].map((u) => ({
      ...u,
      name: u?.name ?? u?.username?.substring(0, u?.username?.indexOf('@'))?.replaceAll(/_/g, ' ')?.toUpperCase(),
    }));

    // SELECT
    // userid,
    //   username,
    //   CONCAT(
    //     UPPER(REPLACE(SUBSTRING_INDEX(username, '@', 1), '_', ' '))
    //   ) AS `name`
    // FROM users WHERE username like "%medallion%"
    // ORDER BY userid DESC

    return (
      <QAHiddenElement showInLowerEnvironments={true}>
        <div
          style={{
            position: 'absolute',
            right: '100px',
            top: '100px',
            padding: '10px',
            background: 'rgba(0, 98, 190, 0.25)',
            border: 'solid black 1px',
            borderRadius: '5px',
          }}
        >
          <h4 style={{ margin: 0, padding: 0 }}>Impersonation Tool</h4>
          <ShowMoreText summary={''}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {users.map(({ userid, username, name }, i) => {
                return (
                  <div key={i}>
                    <button
                      style={{ borderRadius: '5px', padding: '5px', margin: '5px' }}
                      onClick={() => {
                        Actions.impersonateUser({ userid, username, bySession: true });
                        window.location.reload();
                      }}
                    >
                      {name
                        .replace(/P3/, '')
                        .replace(/CONCERT/, '')
                        .trim()}
                    </button>
                  </div>
                );
              })}
            </div>
          </ShowMoreText>
        </div>
      </QAHiddenElement>
    );
  } catch (ex) {
    console.error('qahiddenmini', ex);
    return <div className={'qahiddenmini-error-occured'}></div>;
  }
};
export default QAHiddenMini;
